import type { NavigateFunction } from 'react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { useAuthStore } from '@indipia/shared';
import type { SocialLoginResult } from '../api/social-auth';
import { applyLoginTokens } from './post-login';

// AuthCallbackPage(팝업) ↔ SnsLoginPage(opener) 간 postMessage 페이로드
export const SNS_AUTH_MESSAGE_TYPE = 'sns-auth-result';

export interface SnsAuthMessage {
  type: typeof SNS_AUTH_MESSAGE_TYPE;
  result?: SocialLoginResult;
  error?: string;
}

type SetAuthFn = ReturnType<typeof useAuthStore.getState>['setAuth'];

/**
 * SOCIAL_LOGIN_SUCCESS / SOCIAL_NEED_REGISTER / SOCIAL_REJECTED 결과 처리.
 * AuthCallbackPage(팝업 차단 시 리다이렉트 폴백)와 SnsLoginPage(팝업 postMessage 수신)
 * 양쪽에서 동일 로직을 써야 해서 공용 함수로 분리.
 */
export function applySnsLoginResult(
  result: SocialLoginResult,
  navigate: NavigateFunction,
  setAuth: SetAuthFn,
  queryClient: QueryClient,
): void {
  if (result.resultCode === 'SOCIAL_LOGIN_SUCCESS') {
    applyLoginTokens(result, setAuth, queryClient);
    void navigate('/app', { replace: true });
    return;
  }

  if (result.resultCode === 'SOCIAL_NEED_REGISTER') {
    void navigate('/signup/sns', {
      replace: true,
      state: {
        provider:     result.provider,
        socialId:     result.socialId,
        email:        result.email,
        socialName:   result.socialName,
        mobile:       result.mobile,
        snsLinkToken: result.snsLinkToken,
      },
    });
    return;
  }

  // SOCIAL_REJECTED
  void navigate('/login', {
    replace: true,
    state: { snsError: result.message ?? '소셜 로그인이 거부되었습니다.' },
  });
}
